import React from 'react';
import { Avatar, Rating, Stack, Typography } from '@mui/material';

import RawHtml from '../../legacy/components/base/RawHtml';

/* === COMMENT PROPS ================================================================== */
export interface CommentProps {
  body: string;
  rating: number;
  user: {
    firstName: string;
    lastName: string;
    avatar: { src: string };
    city: string;
  };
}

export const Comment = ({ body, rating, user }: CommentProps) => {
  /* === RENDER ======================================================================= */
  return (
    <Stack width="100%" alignItems="center">
      <Avatar alt="Resmy Sharp" src={user.avatar.src} sx={{ width: 48, height: 48, mb: 3 }}>{user.firstName?.at?.(0)}</Avatar>

      <Rating name="comment-rating" readOnly value={rating} sx={{ color: 'primary.main' }} />

      <Typography color="#232529" fontFamily="Gotham-Book" textAlign="center" mt={3} mb={2.5}>
        <RawHtml content={body} />
      </Typography>

      <Typography color="#232529" fontFamily="Gotham-Medium" fontSize={18} fontWeight={500} mb={0.5}>
        {user.firstName} {user.lastName}
      </Typography>
      <Typography color="#232529" fontFamily="Gotham-Light" fontSize={14} fontStyle="italic">
        {user.city}
      </Typography>
    </Stack>
  );
};
